import { createSentry } from "@swivu/client-api";

createSentry({
  app_name: "Public"
});
